import { render, staticRenderFns } from "./RejectReturn.vue?vue&type=template&id=074ce4d1&scoped=true&"
import script from "./RejectReturn.vue?vue&type=script&lang=js&"
export * from "./RejectReturn.vue?vue&type=script&lang=js&"
import style0 from "./RejectReturn.vue?vue&type=style&index=0&id=074ce4d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ce4d1",
  null
  
)

export default component.exports